module.exports = __webpack_public_path__ + "static/img/bgw.e507e437.png";